// Entry point for the build script in package.json

import "@rails/ujs";
import "trix";
import "@rails/actiontext";
import * as ActiveStorage from "@rails/activestorage";
import "core-js/stable";
// Bootstrap is already imported by Niiwin, so leave this line commented out.
// import "bootstrap";
import "@fortawesome/fontawesome-free/js/all.js";
import "tom-select/dist/js/tom-select.complete.js";

// eslint-disable-next-line import/first
import "./channels";
// eslint-disable-next-line import/first
import "./controllers";
import "./custom_turbo_actions";

ActiveStorage.start();
